import { formatAsUSD } from '@la/utilities';

export function formatUSDAmounts(input: string): string {
  // Regular expression to match USD amounts
  // Matches: $1,000, $123, $123.45, $0, $0.00, etc.
  const usdPattern = /\$(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?)/g;

  return input.replace(usdPattern, (match, amount) => {
    amount = amount.replace(/,/g, '');
    const numericAmount = parseFloat(amount);

    // Convert $0 or $0.00 to "Free"
    if (numericAmount === 0) {
      return 'Free';
    }

    // Add .00 if no decimal places exist
    if (!amount.includes('.')) {
      return formatAsUSD(amount);
    }

    // Return as-is if already has cents
    return match;
  });
}
